<template>
  <div>
    <nav-bar :title="'Badges'" />
    <div class="mobile pt-4">
      <b-container>
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <badges-skeleton />
          </template>
          <badges-unlocked-carrousel
            v-if="badgesUnlocked && badgesUnlocked.length"
            :badges="badgesUnlocked"
          />
          <section id="lockedBadges" class="locked-badgess w-100 p 20 mb-2">
            <badges-locked-list :badges="badgesToUnlocked" :direction="'row'" />
          </section>
        </b-skeleton-wrapper>
      </b-container>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import { getChildLockedBadges, getChildUnlockedBadges } from '@/gamification/services';
import { NavBar } from '@/common/components';
import BadgesSkeleton from '@/gamification/components/skeletons/BadgesSkeleton';
import BadgesUnlockedCarrousel from '@/gamification/components/BadgesUnlockedCarrousel';
import BadgesLockedList from '@/gamification/components/BadgesLockedList';

export default {
  components: {
    NavBar,
    BadgesSkeleton,
    BadgesUnlockedCarrousel,
    BadgesLockedList,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      lockedBadges: {},
      unlockedBadges: [],
      loading: false,
    };
  },
  computed: {
    badgesUnlocked() {
      return this.unlockedBadges || [];
    },
    badgesToUnlocked() {
      return [
        ...(this.lockedBadges.progressive_badges || []),
        ...(this.lockedBadges.skill_badges || []),
      ];
    },
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    getChildId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
  },
  async mounted() {
    this.loading = true;
    const childId = this.getChildId;
    try {
      const responses = await Promise.all([
        getChildLockedBadges({ childId }),
        getChildUnlockedBadges({ childId }),
      ]);
      this.lockedBadges = responses[0];
      this.unlockedBadges = responses[1];
    } catch (error) {
      throw new Error(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

